import { render, staticRenderFns } from "./ex-card.vue?vue&type=template&id=e4d6284a&scoped=true&"
import script from "./ex-card.vue?vue&type=script&lang=js&"
export * from "./ex-card.vue?vue&type=script&lang=js&"
import style0 from "./ex-card.vue?vue&type=style&index=0&id=e4d6284a&prod&lang=scss&scoped=true&"
import style1 from "./ex-card.vue?vue&type=style&index=1&id=e4d6284a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4d6284a",
  null
  
)

export default component.exports